// @mui material components
import Icon from "@mui/material/Icon";

// Styled components
import {
    StyledHeadCellContainer,
    StyledHeadCellContent,
    StyledSortIconContainer,
    StyledSortArrow,
} from './DataTable.styles';

interface DataTableHeadCellProps {
    width?: string | number;
    children: React.ReactNode;
    sorted?: 'none' | 'asce' | 'desc' | false;
    align: 'left' | 'right' | 'center';
    onClick?: () => void;
}

const DataTableHeadCell: React.FC<DataTableHeadCellProps> = ({
    width,
    children,
    sorted,
    align,
    onClick,
    ...rest
}) => (
    <StyledHeadCellContainer
        width={width}
        onClick={() => onClick && onClick()}
    >
        <StyledHeadCellContent
            {...rest}
            align={align}
            sorted={sorted}
        >
            {children}
            {sorted && sorted !== 'none' && (sorted === 'asce' || sorted === 'desc') && (
                <StyledSortIconContainer align={align}>
                    <StyledSortArrow
                        isActive={sorted === "asce"}
                        direction="up"
                    >
                        <Icon>arrow_drop_up</Icon>
                    </StyledSortArrow>
                    <StyledSortArrow
                        isActive={sorted === "desc"}
                        direction="down"
                    >
                        <Icon>arrow_drop_down</Icon>
                    </StyledSortArrow>
                </StyledSortIconContainer>
            )}
        </StyledHeadCellContent>
    </StyledHeadCellContainer>
);


export default DataTableHeadCell; 